import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useUserSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';
import { setUpdatedBalances } from 'js/hooks/user/store/buzz/actions';

export const useSetUpdatedBalance = () => {
    const dispatch = useDispatch();
    const balance = useUserSelector(prop('balance'));
    const previousBalance = usePrevious(balance);

    useEffect(() => {
        if (!balance || !previousBalance || balance.totalAmount === previousBalance.totalAmount) {
            return;
        }

        const updatedBalances = Object.entries(previousBalance.balances).reduce((acc, [key, value]) => {
            if (
                !Object.prototype.hasOwnProperty.call(balance.balances, key)
                || value.amount !== balance.balances[key]?.amount
            ) {
                return [key, ...acc];
            }

            return acc;
        }, []);

        dispatch(setUpdatedBalances(updatedBalances));
    }, [balance, dispatch, previousBalance]);
};
